import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiUrls } from "./ApiUrls";
import { MakerDashboardModel } from "../model/MakerDashboardModel";
import { CheckerDashboardModel } from "../model/CheckerDashboardModel";
import { AdminDashboardModel } from "../model/AdminDashboardModel";
import { InternalModeratorDashboardModel } from "../model/InternalModeratorDashboardModel";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ModerationInchargeDashboardModel } from "../model/ModerationInchargeModel";
import { NodalOfficerDashboardModel } from "../model/NodalOfficerDashboardModel";
import { NocDashboardModel } from "../model/NocDashboardModel";
import { NocPendingCountModel } from "../model/NocPendingCountModel";
import { ExeutiveEngieerHomeDashboardModel } from "../model/ExeutiveEngieerHomeDashboardModel";
import { ICTDashboardDetailModel } from "../model/ICTDashboardDetailModel";
import { ICTDashboardModel } from "../model/ICTDashboardModel";

@Injectable({
  providedIn: "root",
})
export class HomeService {
  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) {}

  fetchMakerDashboard() {
    return this.httpClient.get<MakerDashboardModel>(ApiUrls.home);
  }

  fetchCheckerDashboard() {
    return this.httpClient.get<CheckerDashboardModel>(ApiUrls.home);
  }

  fetchAdminDashboard() {
    return this.httpClient.get<AdminDashboardModel>(ApiUrls.home);
  }
  fetchExeutiveEngieerDashboard() {
    return this.httpClient.get<ExeutiveEngieerHomeDashboardModel>(ApiUrls.home);
  }

  fetchInternalModeratorDashboard() {
    return this.httpClient.get<InternalModeratorDashboardModel>(ApiUrls.home);
  }

  fetchModerationInchargeDashboard() {
    return this.httpClient.get<ModerationInchargeDashboardModel>(ApiUrls.home);
  }

  fetchNOCDashboard() {
    return this.httpClient.get<NocDashboardModel>(ApiUrls.nocDashboard);
  }

  fetchNodalOfficerDashboard() {
    return this.httpClient.get<NodalOfficerDashboardModel>(ApiUrls.home);
  }

  assignModerationCases(data: number) {
    return this.httpClient.get<{ status: string; errorMessage: string }>(
      ApiUrls.assignModerationCasesUrl + "?data=" + data
    );
  }

  releaseModerationCases(userId: string) {
    return this.httpClient.get<{ status: string; errorMessage: string }>(
      ApiUrls.releaseModerationCasesUrl.replace("{userId}", userId)
    );
  }

  //Noc Pending Count

  fetchnOCPendingCount() {
    return this.httpClient.get<NocPendingCountModel>(ApiUrls.nocPendingCount);
  }

  // fetchNocDetails(nocPendingCount:number){
  //   return this.httpClient.get<NocDashboardModel>(ApiUrls.fetchNocDetails);

  // }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }

  fetchICTFilteredDashboard(boardId: number, finYear: string, lotteryEventId: number) {
    let reqParams = "?";
    if(boardId && boardId > 0) {
      reqParams += "boardId="+boardId+"&";
    }
    if(finYear && finYear !== '') {
      reqParams += "finYear="+finYear+"&";
    }
    if(lotteryEventId && lotteryEventId > 0) {
      reqParams += "lotteryEventId="+lotteryEventId+"&";
    }

    if(reqParams.endsWith("&")) {
      reqParams = reqParams.substring(0, reqParams.length - 1);
    }

    if(reqParams === "?") {
      reqParams = "";
    }

    return this.httpClient.get<ICTDashboardModel>(ApiUrls.ictDashboardInnerInitUrl+reqParams); 
  }

  fetchICTDetailDashboard(boardId: number, finYear: string, lotteryEventId: number) {
    let reqParams = "?";
    if(boardId && boardId > 0) {
      reqParams += "boardId="+boardId+"&";
    }
    if(finYear && finYear !== '') {
      reqParams += "finYear="+finYear+"&";
    }
    if(lotteryEventId && lotteryEventId > 0) {
      reqParams += "lotteryEventId="+lotteryEventId+"&";
    }

    if(reqParams.endsWith("&")) {
      reqParams = reqParams.substring(0, reqParams.length - 1);
    }

    if(reqParams === "?") {
      reqParams = "";
    }

    return this.httpClient.get<ICTDashboardDetailModel>(ApiUrls.ictDashboardInnerDetailUrl+reqParams);
  }
}
